import React, { useState } from 'react';
import { Modal, Button, Input, message } from 'antd';

const ForgotPasswordModal = ({ visible, onCancel, onEmailSubmitted }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) {
      message.error('Please enter your email address');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch('https://smtp-blush.vercel.app/api/auth/forgot-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();
      
      if (response.ok && data) {
        message.success('OTP sent to your email address');
        onEmailSubmitted(email);
      } else {
        message.error(data.message || 'Failed to send OTP. Please try again.');
      }
    } catch (error) {
      message.error('Failed to send OTP. Please try again.');
      console.error('Forgot password error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setEmail('');
    onCancel();
  };

  return (
    <Modal
      title="Forgot Password"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button className='bg-primary text-white' key="submit" type="primary" loading={loading} onClick={handleSubmit}>
          Submit
        </Button>,
      ]}
      centered
    >
      <div className="space-y-4">
        <p className="text-gray-600">
          Enter your email address and we'll send you an OTP to reset your password.
        </p>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email Address
          </label>
          <Input
            type="email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            size="large"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ForgotPasswordModal;
